import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Container,
  IconButton,
  Stack,
  Typography,
  Grid,
  CircularProgress,
  Pagination,
} from '@mui/material';
import { Add, FilterAlt } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import OpenFilterDrawer from './OpenFilterDrawer';
import CompetitionCard from './CompetitionCard';
import { fetchCompetitions } from "../../services/Competition";

const Competition = () => {
  const navigate = useNavigate();
  const [openFilter, setOpenFilter] = useState(false);
  const [filters, setFilters] = useState({});
  const [competitions, setCompetitions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState(null);

  const fetchData = async () => {
    try {
      setLoading(true);
      const res = await fetchCompetitions(filters, page);
      console.log("Fetched competitions:", res);
      setCompetitions(res.data?.competitions || []);
      setLastPage(res.data?.last_page || 1); 
    } catch (error) {
      console.error("Error fetching competitions:", error);
    } finally {
      setLoading(false);
    }
  };

  // Fetch when page or filters change
  useEffect(() => {
    fetchData();
  }, [page, filters]);


  const handleApplyFilters = (newFilters) => {
    setFilters(newFilters);
    setOpenFilter(false);
  };



  return (
    <>
      <Container maxWidth="lg" sx={{ mt: { xs: 3, sm: 3, md: 0 }, mb: { xs: 3, sm: 3, md: 0 }, }}>
        <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
          <Typography variant="h5">All Competitions</Typography>
          <Box>

            <IconButton onClick={() => setOpenFilter(true)}>
              <FilterAlt />
              <Typography variant="body2" ml={0.5}>Filters</Typography>
            </IconButton>

            <Button
              variant="contained"
              color="primary"
              onClick={() => navigate('/competition/create')}
              disableElevation
              startIcon={<Add />}
              sx={{ textTransform: 'none', ml: 1 }}
            >
              New Competition
            </Button>
          </Box>
        </Stack>

        <Grid container spacing={2}>
          {loading ? (
            <Grid size={12}>
              <Box display="flex" justifyContent="center" mt={4}>
                <CircularProgress />
              </Box>
            </Grid>
          ) : competitions.length === 0 ? (
            <Grid size={12}>
              <Typography textAlign="center" mt={4}>
                No competitions found.
              </Typography>
            </Grid>
          ) : (
            competitions.map((competition) => (
              <Grid size={{ xs: 12, md: 6 }} key={competition.competition_id}>
                <CompetitionCard competition={competition} />
              </Grid>
            ))
          )}
        </Grid>

        {/* Pagination */}
        {!loading && competitions.length > 1 && lastPage > 1 && (
           <Stack my={4} alignItems="center">
            <Pagination
              count={lastPage}
              page={page}
              onChange={(e, value) => setPage(value)}
              variant="outlined"
              shape="rounded"
              color="primary"
            />
          </Stack>
        )}
      </Container>

      <OpenFilterDrawer
        open={openFilter}
        onClose={() => setOpenFilter(false)}
        onApplyFilters={handleApplyFilters}
      />
    </>
  );
};

export default Competition;
